import Cookies from "js-cookie";
import { useMutation } from "react-query";
import { serverBaseUrl } from "../config/envs";

const add = async (token = null, postData) => {
  const headers = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${serverBaseUrl}/reset_password`, {
    method: "POST",
    headers,
    body: JSON.stringify(postData),
  });
  const data = await response.json();
  console.log("Status Code:", response);
  if (response.status === 400) {
    console.log(data, "data400");
    return data;
  }
  if (response.status === 500) {
    console.log(data, "data500");
    return data;
  }

  if (!response.ok) {
    throw new Error(data);
  }
  return data;
};

export const useResetPasswordMutation = () => {
  const token = Cookies.get("token");
  return useMutation(["resetPassword", token], (postData) =>
    add(token, postData)
  );
};
